var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer-container',{scopedSlots:_vm._u([{key:"contacts",fn:function(){return [_c('footer-contacts')]},proxy:true},{key:"categories",fn:function(){return [_c('footer-categories')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }